import { ReactElement } from 'react'
import Modal from '../../../../components/Modal'
import strings from '../../../../locale/en'
import { ApproveProps } from './typings'

const Reject = ({ handleCancel, handleSubmit }: ApproveProps): ReactElement => {
  const {
    pendingRequests: {
      reject: { title, description }
    }
  } = strings

  return (
    <Modal
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      title={title}
      description={description}
    ></Modal>
  )
}

export default Reject
